import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { IStateTree } from "../../../../store/interfaces";
import { IUser, SolfaAudioType } from "../../../../store/user/models";

import loadableComponent from "./loadable";

const mapStateToProps = ({ user }: IStateTree) => ({
    solfaAudio: (user as IUser).solfaAudio || SolfaAudioType.Solfa,
    solfaKam: (user as IUser).solfaKam || false,
    solfaShort: (user as IUser).solfaShort || false,
});

export default connect(mapStateToProps)(injectIntl(loadableComponent));
